<template>
<div>
    <Modal
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'top':'20%','min-width':'700px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
    
            <FormItem :label="$t('push.addModel.message')" prop="pushMessage" style="width: 500px">
                <Input maxlength="1000"  show-word-limit  type="textarea" v-model.trim="formData.pushMessage" :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>

           
            <FormItem :label="$t('push.addModel.receiverGroup')" prop="receiverGroup"  style="width: 500px">
                <SearchSelect ref="productType" :url="searchProductTypeUrl" labelName='groupName' isMultiple='2'  valName='id' keyword="groupName" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectVal($event,'receiverGroup')"></SearchSelect>
            </FormItem>

            <FormItem :label="$t('push.addModel.image')" prop="pushPhoto" style="width: 500px">
                  <ImgUpload  ref="upLogoImg" :action="uploadUsersAvatar" :hasUpload="hasUpload" :num="1"  @setThumbUrl="setThumbUrlthumb"  @removeThumbUrl='removeThumbUrl'></ImgUpload>
            </FormItem>


            <FormItem>
                <Button :loading="disabled"  type="primary" @click="subData('formData')" style="marginRight:20px">{{$t('save')}}</Button>
                <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import SearchSelect from '../../common/selectList.vue';
import ImgUpload from "@/views/common/upload";
import { mapState } from 'vuex'

    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        components: {
            SearchSelect,
            ImgUpload
        },
        data() {
            return {   
                searchProductTypeUrl: this.config.urlArray.userGroups,
                uploadUsersAvatar:this.config.urlArray.uploadImg, //上传图片接口
                hasUpload: [], //已上传图片
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                    pushMessage: '',
                    receiverGroup:'',
                    pushPhoto:''
                }, 
            }
        },
        watch:{
            showModel(val){
                if(val){
                    
                }
            }
        },
        computed:{
           ...mapState(['local','selectId']),
            ruleCustom(){
                return {//验证
                    pushMessage: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    receiverGroup: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    pushPhoto: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                }
            },

        },
        created(){
            
        },
        methods: {
            setThumbUrlthumb(item) {
            //   console.log("uel", url);
              this.formData.pushPhoto = item.data;
            },
            removeThumbUrl(){
                this.formData.pushPhoto = '';
            },
            selectT(val){
               this.formData['orderDate'] = val
                
            },
            setSelectVal(e,key){
                // console.log('e',e)
                 this.formData[key] = e.nameVal+''
            },
            openOrClose(value) {
                if(value === true) {
                    // if(this.type == 2){//编辑表单时，给表单赋值
                    //     this.formData.name = this.editFormData.name.toString();
                    //     this.formData.mobile = this.editFormData.mobile.toString();
                    //     this.formData.status = this.editFormData.status.toString();
                    //     this.formData.account_per = this.editFormData.account_per.toString();
                    // }        
                    this.$nextTick(()=>{//select赋值
                        // this.$refs.productType.setQuery(null)
                        this.$refs.productType.setQuery(null)
                    }); 
                    this.title = this.type == 1?this.$t('push.addModel.title'):'编辑订单'
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                     this.$refs.productType.clearVal();
                     this.$refs.upLogoImg.clearImg();
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;                     

                        this.axios.post(this.config.urlArray.pushesAdd, {...this.formData,dealerId:this.selectId}).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false;})
                            
                        }).catch((err) => {
                            this.disabled = false;
                            // common.msg('error','提交失败',()=>{this.disabled = false;})
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                if(this.type == 2){
                    delete this.formData.id
                }
            }
        }
    }
</script>

<style lang='less' scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
/deep/ .ivu-modal-mask{
    z-index: 1016 !important;
}
/deep/ .ivu-modal-wrap{
    z-index: 1016 !important;
}
</style>

